export class AzureVmInstanceRestoreResult {
    'instanceId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "instanceId",
            "baseName": "instanceId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureVmInstanceRestoreResult.attributeTypeMap;
    }
    constructor() {
    }
}
